export default function validateEmail(email) {
    return email.match(
        /\S+@\S+\.\S+/
    );
};